import styled from 'styled-components'

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 2px;
`
